import { useState } from 'react'
import { usePrefersReducedMotion } from '../hooks/usePrefersReducedMotion'

// Placeholder paths — swapped for the real HyperFrames-produced assets in a
// follow-up session (see openspec/changes/id-login-ecosystem-reel tasks.md 5.1).
// The poster IS the video's resting frame, so there is never a visual jump
// between the two.
const POSTER_SRC = '/brand/ecosystem-poster.webp'
const VIDEO_WEBM_SRC = '/brand/ecosystem-reel.webm'
const VIDEO_MP4_SRC = '/brand/ecosystem-reel.mp4'

/**
 * Brand-panel hero media: an instant poster image, progressively enhanced by
 * a looping muted video once it loads. Never mounts the <video> element when
 * the visitor prefers reduced motion.
 */
export function BrandPanelMedia() {
  const prefersReducedMotion = usePrefersReducedMotion()
  const [videoFailed, setVideoFailed] = useState(false)

  const showVideo = !prefersReducedMotion && !videoFailed

  return (
    <>
      <img src={POSTER_SRC} alt="" aria-hidden="true" />
      {showVideo ? (
        <video
          poster={POSTER_SRC}
          autoPlay
          muted
          loop
          playsInline
          aria-hidden="true"
          style={{ position: 'absolute', inset: 0 }}
          onError={() => setVideoFailed(true)}
        >
          <source src={VIDEO_WEBM_SRC} type="video/webm" />
          <source src={VIDEO_MP4_SRC} type="video/mp4" />
        </video>
      ) : null}
    </>
  )
}
